import '../src/raphael-sketchpad/json2'
import '../src/raphael-sketchpad/raphael.sketchpad'

